import { render } from "./generateDocumentAdCard.vue?vue&type=template&id=540036ba&scoped=true"
import script from "./generateDocumentAdCard.vue?vue&type=script&lang=js"
export * from "./generateDocumentAdCard.vue?vue&type=script&lang=js"

import "./generateDocumentAdCard.vue?vue&type=style&index=0&id=540036ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540036ba"]])

export default __exports__